import fetchWithCache from './fetchWithCache';

const fetchStandardFeatures = ({ v3ServicesPath, modelPath, styleId }) => {
  const url = `${v3ServicesPath}/standard-features/${modelPath}/${styleId}`;
  return fetchWithCache(url).then((data) => data.features);
};

export default fetchStandardFeatures;
